export const PAPER_ZOOM_SETTINGS = {
  min: 0.05,
  max: 2.5,
};

export const STORAGE_KEYS = {
  MAP_ZOOM_LEVEL: 'map_zoom_level',
  MAP_POSITION: 'map_position',
  LAST_SCENARIO: 'last_scenario_url',
};
